export const OPPORTUNITIES_TABLE =
  'ALLGRANTS&SAVINGS(Automated-AccountsReceivable)';

export const OPPORTUNITY_AUDIT_TABLE = 'OpportunityAuditLog';
export const OPPORTUNITY_SNAPSHOT_TABLE = 'OpportunityLedgerSnapshots';

export const AUDIT_TRACKED_FIELDS = [
  'CompanyName',
  'UpgradeName',
  'OpportunityName',
  'Status',
  'AwardedAmount',
  'AdjustedAmount',
  'Amount',
  'SuccessFeeAmount',
  'CollectedDollarsToDate',
  'InvoiceSentDate',
  'PaidInvoiceBy',
  'Assignee',
  'EstHearBackDate',
  'ClientCashReceivedDate',
  'CompanyID',
  'GrantID',
];

export const MONEY_AUDIT_FIELDS = [
  'Status',
  'AwardedAmount',
  'AdjustedAmount',
  'Amount',
  'SuccessFeeAmount',
  'CollectedDollarsToDate',
  'InvoiceSentDate',
  'PaidInvoiceBy',
  'EstHearBackDate',
  'ClientCashReceivedDate',
];

export function pickAuditFields(fields = {}) {
  const picked = {};
  AUDIT_TRACKED_FIELDS.forEach((name) => {
    if (Object.prototype.hasOwnProperty.call(fields, name)) {
      picked[name] = fields[name];
    }
  });
  return picked;
}

export function valuesEqual(left, right) {
  if (left == null && right == null) return true;
  if (Array.isArray(left) || Array.isArray(right)) {
    return JSON.stringify(left ?? []) === JSON.stringify(right ?? []);
  }
  if (typeof left === 'object' || typeof right === 'object') {
    return JSON.stringify(left ?? null) === JSON.stringify(right ?? null);
  }
  return String(left) === String(right);
}

export function diffAuditFields(before = {}, after = {}) {
  const keys = new Set([
    ...Object.keys(pickAuditFields(before)),
    ...Object.keys(pickAuditFields(after)),
  ]);
  const changes = {};
  keys.forEach((key) => {
    const prev = before?.[key];
    const next = after?.[key];
    if (!valuesEqual(prev, next)) {
      changes[key] = { before: prev ?? null, after: next ?? null };
    }
  });
  return changes;
}

export function moneyFieldsTouched(changes = {}) {
  return Object.keys(changes).some((key) => MONEY_AUDIT_FIELDS.includes(key));
}

export function truncateJson(value, max = 90000) {
  const text = JSON.stringify(value ?? null);
  if (text.length <= max) return text;
  return `${text.slice(0, max)}…`;
}

export function todayStamp(date = new Date()) {
  return date.toISOString().slice(0, 10);
}
